<script lang="ts" setup>
import { computed } from 'vue'
import type { RouterLinkProps } from 'vue-router'

interface AppLinkProps extends RouterLinkProps {
  to: string
  target?: string
  class?: any
  forceExternal?: boolean
}

const props = defineProps<AppLinkProps>()
const className = computed(() => props.class)

const isValidLink = computed(() => {
  return typeof props.to === 'string' && props.to.length > 0
})

const isInternal = computed(() => {
  if (props.forceExternal)
    return false

  return (
    isValidLink.value
    && !/^(http|https|ftp):\/\/|mailto:|\.com$/.test(props.to)
  )
})
</script>

<template>
  <!-- If it's an internal link, use vue-router's router-link -->
  <router-link v-if="isInternal && isValidLink" v-bind="props">
    <slot />
  </router-link>

  <!-- If it's an external link, use a regular a tag -->
  <a v-else-if="!isInternal && isValidLink" :href="to" :class="className">
    <slot />
  </a>

  <!-- If it's not a valid link, just render the slot -->
  <template v-else>
    <slot />
  </template>
</template>
